import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getReferralsCount } from 'app/pages/Gamification/api';
import type { RootState } from 'redux/types';

export const CREDITS_PER_INDICATION = 10;

const FIVE_MINUTES = 1000 * 60 * 5;
const THIRTY_MINUTES = 1000 * 60 * 30;

export const INDICATION_PROGRESS_QUERY_KEY = ['gamification', 'referralsCount'] as const;

export interface UseIndicationProgressResult {
	count: number;
	credits: number;
	loading: boolean;
	refetch: () => void;
}

export const useIndicationProgress = (): UseIndicationProgressResult => {
	const { authToken } = useSelector((state: RootState) => state.auth);

	const { data, isLoading, refetch } = useQuery<{ count: number }>({
		queryKey: INDICATION_PROGRESS_QUERY_KEY,
		queryFn: async () => {
			const result = await getReferralsCount(authToken);
			return { count: Number(result?.count) || 0 };
		},
		enabled: !!authToken,
		staleTime: FIVE_MINUTES,
		cacheTime: THIRTY_MINUTES,
	});

	const count = data?.count ?? 0;

	return {
		count,
		credits: count * CREDITS_PER_INDICATION,
		loading: isLoading,
		refetch,
	};
};
